<script>
import options from './StafetEditHoldFlow.options'
export default options
</script>

<template>
  <article class="kb-stafet-edit-hold-flow">
    <StafetHeader
      :steps="headerSteps"
      :title="labels.title"
      :description="labels.description"
    />

    <div class="kb-stafet-donation-flow__step">
      <component
        :is="currentStepName"
        :labels="labels"
        :nextStepCallback="nextStepCallback"
        :previousStepCallback="previousStepCallback"
        :displayInputError="displayInputError"
        :submitCallback="submitCallback"
        :stafetId="stafetId"
        :loggedIn="loggedIn"
        :userData="userData"
        :holdData="holdData"
        :isSubmitting="isSubmitting"
      />
    </div>
  </article>
</template>
